__turbopack_context__.v({
  "react-international-phone-flag-emoji": "flag-emoji-module__b5Dnca__react-international-phone-flag-emoji",
});
